<template>
  <div>
    <div class="bonus">
      <div class="bonus-title">
        <div style="display:flex">
          <slot name="groupName"></slot>
          <el-input v-model="bonusInfo.groupName" placeholder="请输入组合名称" v-if="type !== 'show'" :disabled="type === 'change' && !!bonusInfo.groupId"></el-input>
          <span style="margin-left:20px;font-weight:700" v-else>{{bonusInfo.groupName}}</span>
        </div>
        <!-- <div>
          <el-button type="primary" v-if="" plain>新增</el-button>
          <el-button type="danger" plain>删除</el-button>
        </div>-->
        <slot></slot>
      </div>
      <el-table
        :data="bonusInfo.bonusDetail"
        class="bonus-table"
        :header-cell-style="{
            background: '#f0f0f0',
            color: '#606266',
            lineHeight: '20px',
            fontSize: '14px',
            textAlign: 'center',
          }"
      >
        <el-table-column fixed="left" min-width="260px" align="center">
          <template slot="header">
            <div>
              <i class="require-icon" v-if="type !== 'show'">*</i> 赠酒SKU
            </div>
          </template>
          <template slot-scope="scope">
            <div>
              {{scope.row.skuName}}
              <i class="edit-sku el-icon-edit" @click="changeSku(scope.$index)" v-if="type !== 'show' && (!scope.row.isActiveUUID || themeStatus < 200)"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-for="item,index in monthList" :key="index" min-width="240px">
          <template slot="header">
            <div>
              <i class="require-icon" v-if="type !== 'show'">*</i>
              {{item.year}}年{{item.month}}月
            </div>
          </template>
          <template slot-scope="scope">
            <div style="text-align:center">
              <el-input-number
                v-model="scope.row.values[index].value"
                style="margin-right:5px"
                placeholder="请输入"
                v-if="type !== 'show'"
                @blur="handleToFixed(scope.$index, index)"
                :disabled="checkChangeDate(item)"
              ></el-input-number>
              <span v-else>{{scope.row.values[index].value | thousandSymbol}}</span> 箱/次
              <el-tooltip effect="light" content="一键同步" placement="top-start" v-if="index !== monthList.length - 1 && type !== 'show'">
                <i class="el-icon-download sync-value" @click="syncValue(scope.$index,index)"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" min-width="160px" align="center" v-if="type !== 'show'">
          <template slot="header">
            <div>操作</div>
          </template>
          <template slot-scope="scope">
            <div>
              <i
                class="el-icon-circle-plus handle-icon-plus"
                v-if="scope.$index === bonusInfo.bonusDetail.length - 1"
                @click="addBonusSku"
              ></i>
              <i class="el-icon-remove handle-icon-remove" @click="removeBonusSku(scope.$index)" v-if="(!scope.row.isActiveUUID || themeStatus < 200 )&& bonusInfo.bonusDetail.length > 1"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <RegionSkuDialog ref="regionSkuDialog" @setBonusBeerSku="setBonusBeerSku"></RegionSkuDialog>
  </div>
</template>

<script>
import RegionSkuDialog from '@/views/trade/perfect2022/components/region-sku-dialog.vue'
export default {
  props: {
    bonusBeerInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    monthList: {
      type: Array,
      default: () => {
        return []
      }
    },
    type: {
      type: String,
      default: 'edit'
    },
    themeStatus: {
      default: 0
    },
    handleType: {
      type: String,
      default: ''
    }
  },
  components: {
    RegionSkuDialog
  },
  data () {
    return {
      index: '',
      bonusInfo: {}
    }
  },
  created () {
    this.init()
  },
  watch: {
    monthList () {
      this.bonusInfo.bonusDetail.forEach(bonusSkuItem => {
        bonusSkuItem.values = []
        this.monthList.forEach(item => {
          let obj = {
            month: item.year + '-' + item.month,
            value: undefined
          }
          bonusSkuItem.values.push(obj)
        })
      })
    }

  },
  methods: {
    init () {
      this.bonusInfo = Object.assign({}, this.bonusBeerInfo)
      if (!this.bonusInfo.bonusDetail.length) {
        this.bonusInfo.bonusDetail.push(
          {
            skuCode: '',
            skuName: '',
            values: []
          }
        )
        this.bonusInfo.bonusDetail.forEach(bonusSkuItem => {
          bonusSkuItem.values = []
          this.monthList.forEach(item => {
            let canChange = this.checkChangeDate(item)
            let obj = {
              month: item.year + '-' + item.month,
              value: canChange ? 0 : undefined
            }
            bonusSkuItem.values.push(obj)
          })
        })
      } else {
        if (this.handleType && this.handleType !== 'new') {
          this.bonusInfo.bonusDetail.forEach(detail => {
            detail.values = detail.values.filter(item => {
              const year = new Date().getFullYear()
              const month = new Date().getMonth() + 1
              const strYear = new Date(item.month).getFullYear()
              const strMonth = new Date(item.month).getMonth() + 1
              if (year < strYear || (year === strYear && strMonth >= month)) {
                return item
              }
            })
          })
        }
      }
    },
    changeSku (index) {
      this.index = index
      let obj = {}
      obj.skuName = this.bonusInfo.bonusDetail[index]?.skuName
      obj.skuCode = this.bonusInfo.bonusDetail[index]?.skuCode
      this.$refs.regionSkuDialog.handleShowDialog(obj)
    },
    setBonusBeerSku (val) {
      this.$set(this.bonusInfo.bonusDetail[this.index], 'skuCode', val.skuCode)
      this.$set(this.bonusInfo.bonusDetail[this.index], 'skuName', val.skuName)
    },
    addBonusSku () {
      let list = []
      this.monthList.forEach(item => {
        let canChange = this.checkChangeDate(item)
        let obj = {
          month: item.year + '-' + item.month,
          value: canChange ? 0 : undefined
        }
        list.push(obj)
      })

      this.bonusInfo.bonusDetail.push({
        skuCode: '',
        skuName: '',
        values: list
      })
    },
    removeBonusSku (index) {
      this.bonusInfo.bonusDetail.splice(index, 1)
    },
    syncValue (index, monthIndex) {
      let val = this.bonusInfo.bonusDetail[index].values[monthIndex].value
      this.bonusInfo.bonusDetail[index].values = this.bonusInfo.bonusDetail[index].values.map((item, itemIndex) => {
        if (itemIndex > monthIndex) {
          item.value = val
        }
        return item
      })
    },
    checkChangeDate (date) {
      let nowDate = new Date().getTime()
      let year = new Date(date.year.toString()).getFullYear()
      let month = new Date(date.month.toString()).getMonth() + 1
      let newMonth = ++month
      if (newMonth === 13) {
        year++
        month = 1
      }
      // 下月第一天
      let lastDay = new Date(`${year}/${month}`).getTime()
      // 禁止修改
      if (this.type === 'change' && nowDate >= lastDay) {
        return true
      }
      // 允许修改
      return false
    },

    checkDecimalsCanZero: function (rule, value, callback) {
      if (Number(value) < 0 || !/^(-)?(0|[1-9]\d*)(\s|$|\.\d{1,2}\b)/.test(value) || (value % 0.5)) {
        callback(new Error('请输入整数或者0.5的倍数'))
      } else {
        callback()
      }
    },
    handleToFixed (skuIndex, index) {
      const obj = { ...this.bonusInfo.bonusDetail[skuIndex].values[index] }
      if (obj.value === '' || obj.value === undefined) return
      this.checkDecimalsCanZero('', obj.value, (error) => {
        if (error) {
          this.$message.warning(`${error.message}`)
        }
      })
      obj.value = this.setToFixed(obj.value)
      this.bonusInfo.bonusDetail[skuIndex].values.splice(index, 1, obj)
    },
    setToFixed (num) {
      if (num % 0.5) {
        return undefined
      }
      if (Math.ceil(num) > 0) {
        return Number(num).toFixed(2)
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table ::v-deep tr {
  background: #f8f8f8;
}
.require-icon {
  color: #c8102d;
  font-size: 16px;
  font-weight: 700;
  // margin-right: 10px;
}
.handle-icon-plus,
.handle-icon-remove {
  font-size: 22px;
  cursor: pointer;
}
.handle-icon-plus {
  color: #64d795;
}
.handle-icon-remove {
  color: #c92e34;
}
.bonus {
  // padding: 0 20px;
  box-sizing: border-box;
}
.bonus-title {
  display: flex;
  justify-content: space-between;
  line-height: 40px;
  .el-input {
    width: 150px;
    margin-left: 20px;
  }
  .el-button {
    height: 30px;
    padding: 0 20px;
  }
}
.bonus-table {
  .el-input-number {
    width: 80px;
  }
}
.edit-sku {
  cursor: pointer;
  color: #409eff;
  font-size: 16px;
}
.sync-value {
  display: inline-block;
  width: 30px;
  height: 25px;
  transform: rotate(-90deg);
  font-size: 20px;
  color: #409eff;
  cursor: pointer;
}
</style>
